/**
 * PDP quantity-input protection.
 *
 * The Pareto (P Quantity Breaks & Bundles) app sometimes strips the native
 * <quantity-input> or hidden quantity input from the PDP <product-form> after
 * the initial render — whether because of tier/group mode detection, a timing
 * race in its init, or a partial crash. Symptoms: qty control sometimes shows
 * on refresh, sometimes doesn't, on the same product.
 *
 * This script guarantees the form always has a working quantity control:
 *   1) After a short delay (letting Pareto finish its DOM manipulation),
 *      check whether any qty field exists in the PDP <product-form>.
 *   2) If not, inject a fallback <quantity-input> before the Add-to-cart
 *      button. It carries .pareto-hide-variant so Pareto's own PDP CSS rule
 *      (`.product-info:has(.otTableOffer):not(:has(.omg-offer)) {...}`) hides
 *      or reveals it based on whether Pareto has populated its widget.
 *   3) A MutationObserver keeps watching the form; if Pareto later removes
 *      the qty field, we re-inject it.
 */
(function () {
  const mainProduct = document.querySelector('.cc-main-product');
  if (!mainProduct) return;

  const productForm = mainProduct.querySelector('product-form form');
  if (!productForm) return;

  const addToCartContainer = productForm.querySelector('.product-info__add-to-cart');
  if (!addToCartContainer) return;

  const hasQtyControl = () =>
    !!productForm.querySelector('quantity-input') ||
    !!productForm.querySelector('input[type="hidden"][name="quantity"]') ||
    !!productForm.querySelector('input[type="number"][name="quantity"]');

  const injectFallback = () => {
    if (hasQtyControl()) return;

    const addBtn = productForm.querySelector('button[name="add"]');
    if (!addBtn) return;

    const addButtonWrapper = addBtn.closest('.product-info__add-button') || addBtn;

    const tmpl = document.createElement('template');
    tmpl.innerHTML = `
      <quantity-input class="inline-block pareto-hide-variant">
        <label class="label visually-hidden" for="quantity-pdp-fallback">Quantity</label>
        <div class="qty-input qty-input--combined inline-flex items-center w-full">
          <button type="button" class="qty-input__btn btn btn--minus no-js-hidden" name="minus" aria-controls="quantity-pdp-fallback">
            <span class="visually-hidden">Decrease quantity</span>
          </button>
          <input type="number" class="qty-input__input input" id="quantity-pdp-fallback" name="quantity" min="1" value="1">
          <button type="button" class="qty-input__btn btn btn--plus no-js-hidden" name="plus" aria-controls="quantity-pdp-fallback">
            <span class="visually-hidden">Increase quantity</span>
          </button>
        </div>
      </quantity-input>
    `.trim();

    addToCartContainer.insertBefore(tmpl.content.firstElementChild, addButtonWrapper);
  };

  // Give Pareto ~1.2s to do whatever it's going to do, then ensure qty exists.
  setTimeout(injectFallback, 1200);

  // If Pareto removes it later, put it back.
  const observer = new MutationObserver(() => {
    if (!hasQtyControl()) injectFallback();
  });
  observer.observe(productForm, { childList: true, subtree: true });
})();
